module.exports = __webpack_public_path__ + "static/media/cover.616e469b.jpg";